import megaphoneicon from "./megaphone_icon_24px.png";
import megaphoneicontransparent from "./megaphone_icon_transparent_24px.png";

type MegaphoneIconProps = {
  color?: "green" | "transparent";
};

const MEGAPHONE_IMAGES: Record<"green" | "transparent", string> = {
  green: megaphoneicon,
  transparent: megaphoneicontransparent,
};

export const MegaphoneIcon = ({ color }: MegaphoneIconProps) => (
  <img src={MEGAPHONE_IMAGES[color || "green"]} alt="Megaphone icon" />
);
